import React, { useState, useEffect } from "react";
import { icons } from "./icons";
import { useNavigate, useLocation } from "react-router-dom";
import { setLoginData } from "../../redux/slices/userSlice";

const Aside = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [activeItemId, setActiveItemId] = useState("/dashboard"); // Track the active item
  const [isMobile, setIsMobile] = useState(false);
  const [partnerinfo, setPartnerInfo] = useState({});

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1028);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData?.partnerName) {
      setPartnerInfo({
        partnerName: userData.partnerName,
        partnerLogo: userData.partnerLogo || null,
      });
    }
  }, []);

  useEffect(() => {
    setActiveItemId(location.pathname);
  }, [location.pathname]);

  const handleClick = (item) => {
    if (item === "/") {
      setLoginData(false);
      localStorage.removeItem("userData");
    }
    setActiveItemId(item); // Set the active item when clicked
    navigate(item);
  };

  const handleIconCLick = () => {
    setActiveItemId("/dashboard");
    navigate("/dashboard");
  };

  return (
    <>
      {isMobile ? (
        // mobileHeaderi mechica mobileAsid@
        <> </>
      ) : (
        <aside
          className={`sticky top-0 shadow-xl h-screen ${
            isCollapsed ? "w-[80px]" : "w-[284px]"
          } transition-all duration-300 flex flex-col`}
        >
          <div className="flex items-center gap-3 px-6 py-6">
            <img
              src={isCollapsed ? "/assets/Small_logo.png" : "/assets/Logo.png"}
              alt="my service"
              className={`cursor-pointer transition-all duration-300`}
              onClick={handleIconCLick}
            />
          </div>
          <div className="flex flex-col items-center gap-1 py-6 px-6">
            {icons.map((item) => (
              <div
                key={item.id}
                className={`flex w-full gap-3 py-2.5 px-5 cursor-pointer ${
                  activeItemId === item.path
                    ? "bg-primary text-white"
                    : "hover:bg-lightOrange hover:text-primary"
                } rounded-[99px] ${
                  isCollapsed ? "justify-center" : "justify-start"
                }`}
                onMouseEnter={() => setHoveredItemId(item.id)}
                onMouseLeave={() => setHoveredItemId(null)}
                onClick={() => handleClick(item.path)}
              >
                <div
                  className={`flex items-center ${
                    isCollapsed ? "w-8 h-8" : ""
                  }`}
                >
                  {item.svg(
                    activeItemId === item.path
                      ? "#FFFFFF"
                      : hoveredItemId === item.id
                      ? "#EE5222"
                      : "#181F46"
                  )}
                </div>
                {!isCollapsed && (
                  <span
                    className={`prose-t16_medium ${
                      activeItemId === item.path ? "text-white" : ""
                    }`}
                  >
                    {item.section}
                  </span>
                )}
              </div>
            ))}
          </div>
          {/* Toggle Button */}
          <div className="mt-auto flex justify-between py-6 px-6">
            {!isCollapsed && (
              <div className="flex gap-3">
                {partnerinfo?.partnerLogo ? (
                  <img
                    src={partnerinfo.partnerLogo}
                    alt="partner logo"
                    className="w-[40px] h-[40px] rounded-full"
                  />
                ) : (
                  <svg
                    fill="#BFBFBF"
                    height="40px"
                    width="40px"
                    viewBox="0 0 512.001 512.001"
                    xmlns="http://www.w3.org/2000/svg"
                    className="rounded-full"
                  >
                    <g>
                      <path
                        d="M160.235,276.571l-144.5-159.983c-9.383,5.578-15.734,15.711-15.734,27.414v256.005c0,17.672,14.328,31.994,32,31.994
                        h268.625l-58.867-65.17C196.993,360.155,162.407,322.662,160.235,276.571z"
                      />
                      <path
                        d="M480.001,112.001h-112l-23.156-46.313c-5.422-10.84-16.5-17.687-28.625-17.687H195.782
                        c-12.125,0-23.203,6.848-28.625,17.688l-10.836,21.672L87.782,10.594C75.985-2.539,55.735-3.61,42.594,8.211
                        c-13.141,11.828-14.203,32.063-2.375,45.196l399.992,448c6.313,7.024,15.031,10.594,23.797,10.594
                        c7.625,0,15.281-2.711,21.391-8.211c13.141-11.828,14.203-32.067,2.375-45.2l-23.734-26.59h15.961c17.672,0,32-14.321,32-31.994
                        V144.002C512.001,126.33,497.672,112.001,480.001,112.001z M237.196,177.94c6.086-1.219,12.359-1.938,18.805-1.938
                        c53.016,0,96,42.981,96,96.002c0,10.223-1.758,19.996-4.727,29.227L237.196,177.94z"
                      />
                    </g>
                  </svg>
                )}
                <div className="flex flex-col items-start">
                  <span className="prose-t12_medium text-slateGray">
                    Բարի վերադարձ
                  </span>
                  <span className="prose-t12_bold text-midnightBlue">
                    {partnerinfo?.partnerName}
                  </span>
                </div>
              </div>
            )}
            <button
              onClick={toggleSidebar}
              className="text-gray-600 hover:text-primary focus:outline-none"
            >
              {isCollapsed ? (
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="25"
                    height="25"
                    rx="12.5"
                    fill="white"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="25"
                    height="25"
                    rx="12.5"
                    stroke="#E2E8F0"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.8344 16.7657C10.522 16.4533 10.522 15.9467 10.8344 15.6343L13.4687 13L10.8344 10.3657C10.522 10.0533 10.522 9.54673 10.8344 9.23431C11.1468 8.9219 11.6534 8.9219 11.9658 9.23431L15.1658 12.4343C15.4782 12.7467 15.4782 13.2533 15.1658 13.5657L11.9658 16.7657C11.6534 17.0781 11.1468 17.0781 10.8344 16.7657Z"
                    fill="#081021"
                  />
                </svg>
              ) : (
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="25"
                    height="25"
                    rx="12.5"
                    fill="white"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="25"
                    height="25"
                    rx="12.5"
                    stroke="#E2E8F0"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1658 9.23431C15.4782 9.54673 15.4782 10.0533 15.1658 10.3657L12.5315 13L15.1658 15.6343C15.4782 15.9467 15.4782 16.4533 15.1658 16.7657C14.8534 17.0781 14.3468 17.0781 14.0344 16.7657L10.8344 13.5657C10.522 13.2533 10.522 12.7467 10.8344 12.4343L14.0344 9.23431C14.3468 8.9219 14.8534 8.9219 15.1658 9.23431Z"
                    fill="#081021"
                  />
                </svg>
              )}
            </button>
          </div>
        </aside>
      )}
    </>
  );
};

export default Aside;
